module.exports = __webpack_public_path__ + "img/responsible-betting.071e6360.svg";